import { timeNumToText } from '../../utils/utils'
import { log } from '@/utils/log'

// 直播开始倒计时
let timer = 0

// sdk文档 http://open.talk-fun.com/docs/js/sdk.js.live.html

const init = function (_this, ak, course) {
    const MT = window.MT
    const LIVESDK = new MT.SDK.main(ak, {
        config: {
            techOrder: 'HLS',
            controls: true,
        },
        video: {
            autoplay: true,
            controls: course && course.type !== 1 ? true : false,
            preload: 'auto',
            poster: false,
        },
    })
    _this.LIVESDK = LIVESDK

    // 直播间初始化信息
    LIVESDK.setMediaControl({
        volumeButton: true,
        fullscreenButton: true,
    })
    let _showState = false
    LIVESDK.mainPlayer('player-content', 'maituoPlayer', () => {
        if (!_showState) {
            _showState = true
        setTimeout(() => {
            if (_this.setLiveStartBg) {
                _this.setLiveStartBg()
            }
        }, 300)
        }
    })
    LIVESDK.camera('camera-player', 'modCameraPlayer', function () {})
    LIVESDK.whiteboardPlayer('whiteboard-content', function () {})
    LIVESDK.on('live:tech:order', (techOrderKey) => {
        LIVESDK.playerTechOrder(techOrderKey)
    })

    LIVESDK.on('member:join:other', function () {
        // console.log(res.member.nickname +'进入房间')
    })

    LIVESDK.on('live:network:list', (list) => {
        _this.networkLineList = list
        try {
            if (list[0]) {
                _this.LIVESDK.setLine(list[0]['key'])
            }
        } catch (_) {
            console.log(_)
        }
    })
    LIVESDK.on('live:camera:play', () => {
        _this.$toast.clear()
    })

    // 链接相关事件
    LIVESDK.on('connect', () => {
        // 获取已提问数据
        LIVESDK.getQuestion((question) => {
            _this.updateQuestionList(question.data || {}, 'list')
        })
        // 初始化欢脱 用户ID
        _this.HT_userInfo = _this.LIVESDK.roomObject.user
        try {
            const content = window.MT.announce.notice.content
            if (content) {
                _this.noticeMessage = content
                _this.isShowNotice = true
            } else {
                _this.isShowNotice = false
            }

            const rollContent = window.MT.announce.roll.content
            if (rollContent) {
                _this.updateChatList([{ thirdType: 'broadcast', msg: rollContent }])
            }
        } catch (error) {
            _this.isShowNotice = false
        }
    })
    LIVESDK.on('connect_failed', () => {
        console.log('连接失败')
    })
    LIVESDK.on('connect_error', () => {
        console.log('连接出现错误')
    })
    LIVESDK.on('disconnect', () => {
        console.log('连接已断开')
    })
    LIVESDK.on('reconnect', () => {
        console.log('重新连接')
    })
    LIVESDK.on('reconnecting', () => {
        console.log('重新连接中。。。。')
    })
    LIVESDK.on('reconnect_error', () => {
        console.log('重新连接错误')
    })
    LIVESDK.on('reconnect_failed', () => {
        console.log('重新连接失败')
    })
    LIVESDK.on('error', (error) => {
        _this.onShowExceptionView(`${error.body}`)
    })

    // 房间
    LIVESDK.on('network:status', (networkStatus) => {
        console.log('networkStatus', networkStatus)
    })
    LIVESDK.on('member:robots', (robots) => {
        console.log('member:robots', robots)
    })

    // 聊天
    let chatTime = 0
    let chatList = []
    let chatTimer = 0
    LIVESDK.on('chat:send', (chat) => {
        chatList.push(chat)
        if (chat.time !== chatTime) {
            clearTimeout(chatTimer)
            chatTime = chat.time
            _this.updateChatList(chatList)
            chatList = []
        }
        chatTimer = setTimeout(() => {
            if (chatList.length !== 0) {
                chatTime = 0
                _this.updateChatList(chatList)
                chatList = []
            }
        }, 3000)
    })

    // 禁言个人：chat:disbale
    // 个人解除禁言: chat:enable
    // 全体禁言：chat:disable:all
    // 全体解禁：chat:enable:all
    LIVESDK.on('chat:disable:all', (res) => {
        if (res.status == 1) {
            _this.chatMessage = ''
            _this.isInputStatus = false
        } else {
            _this.isInputStatus = true
        }
    })

    // 直播期间状态变化
    LIVESDK.on('live:start', () => {
        clearInterval(timer)
        _this.liveStatus = 1
    })
    LIVESDK.on('live:stop', () => {
        _this.onShowExceptionView(1)
    })
    LIVESDK.on('live:wait', () => {
        _this.courseInfo = LIVESDK.roomObject.course.info
        _this.liveStatus = -1
        try {
            const nowTime = parseInt(LIVESDK.roomObject.course.srvTime)
            const startTime = parseInt(LIVESDK.roomObject.course.start_time)
            const timeDiff = startTime - nowTime
            if (timeDiff < 1800 && timeDiff > 0) {
                let timeNum = Math.abs(timeDiff)
                clearInterval(timer)
                timer = setInterval(() => {
                    if (timeNum <= 1) {
                        clearInterval(timer)
                        _this.countDownText = 0
                    } else {
                        _this.countDownText = timeNumToText(timeNum)
                        timeNum -= 1
                    }
                }, 1000)
            } else if (timeDiff < 0) {
                _this.countDownText = 0
            } else if (timeDiff > 1800) {
                const day = parseInt(timeDiff / (24 * 60 * 60))
                const hours = parseInt((timeDiff % (24 * 60 * 60)) / (60 * 60))
                const minute = parseInt((timeDiff % (60 * 60)) / 60)
                let text = day ? `${day}天` : ''
                text += hours ? `${hours}小时` : ''
                text += minute ? `${minute}分钟` : ''
                _this.countDownText = text
            }
        } catch (error) {
            console.log(error)
        }
    })
    LIVESDK.on('live:course:access:error', (res) => {
        console.log('live:course:access:error', res)
        if (res.code == 1262 || res.data.action == 'stop') {
            _this.onShowExceptionView(1)
        } else {
            _this.onShowExceptionView(`课程异常, ${res.code}`)
        }
        log('live-m', 'live:course:access:error', JSON.stringify(res))
    })
    LIVESDK.on('system:room:error', (res) => {
        _this.onShowExceptionView(`直播间错误, ${res.code || JSON.stringify(res)}`)
        log('live-m', 'system:room:error', JSON.stringify(res))
    })

    // 用户相关操作
    LIVESDK.on('member:forceout', () => {
        _this.onShowExceptionView(2)
    })
    LIVESDK.on('member:kick', () => {
        _this.onShowExceptionView('直播间错误 10034')
    })
    LIVESDK.on('member:forbidden', () => {
        _this.onShowExceptionView('进入直播间失败，请联系助教老师')
    })

    // 抽奖
    LIVESDK.on('lottery:start', () => {
        _this.onSetLuckDrawStatus(1)
    })
    LIVESDK.on('lottery:stop', (res) => {
        if (res.result && res.result.length !== 0) {
            let status = false
            res.result.forEach((item) => {
                if (_this.HT_userInfo && item.xid == _this.HT_userInfo.xid) {
                    status = true
                }
            })
            _this.luckDrawUserName = res.result
            if (status) {
                _this.onSetLuckDrawStatus(4)
            } else {
                _this.onSetLuckDrawStatus(3)
            }
        } else {
            _this.onSetLuckDrawStatus(3)
        }
    })

    // 自定义推送商品
    LIVESDK.on('third:sell_product', (res) => {
        _this.pushProductList.unshift({
            productNo: res.productNo,
            type: res.type,
        })
    })
    // 自定义推送消息
    LIVESDK.on('third:system_message', (res) => {
        if (res.type === 'reward') {
            const msg = `${res.name} ${res.action} ${res.target}`
            _this.updateReward(msg)
        } else if (res.type === 'to_pay') {
            _this.barrageData.push({
                content: `${res.name} ${res.action} ${res.target || ''}`,
            })
            // _this.updateChatList({
            //     msg: `<span class="nickname">${res.name}</span> ${res.action} <span>${res.target}</span>`,
            //     thirdType: 'userToPay',
            // })
        }
    })
    // 自定义抽奖
    LIVESDK.on('third:lottery', (res) => {
        if (res.type === 'start') {
            _this.onSetLuckDrawStatus(1)
        } else if (res.type === 'stop') {
            _this.luckDrawUserName = [
                {
                    nickname: res.nickname,
                },
            ]
            _this.onSetLuckDrawStatus(3)
        }
    })

    // 伪直播，自定义消息
    LIVESDK.on('third:dummy_message', (res) => {
        console.log(res)
        _this.updateChatList([
            {
                msg: res.msg,
                nickname: res.nickname,
                role: res.role,
                time: parseInt(Date.now() / 1000),
                uid: res.uid,
                old: 1,
            },
        ])
    })

    // 公告：announce:notice
    // 通知：announce:roll
    // 广播：broadcast
    LIVESDK.on('announce:notice', (res) => {
        _this.noticeMessage = res.content || ''
        if (res.content) {
            _this.isShowNotice = true
        }
    })
    LIVESDK.on('broadcast', (res) => {
        _this.updateChatList([
            {
                ...res,
                thirdType: 'broadcast',
                msg: res.message,
            },
        ])
    })
    LIVESDK.on('announce:roll', (res) => {
        _this.updateChatList([{ thirdType: 'broadcast', msg: res.content }])
    })

    // 问答
    LIVESDK.on('question:reply', (res) => {
        console.log('回复', res)
        _this.updateQuestionList(res, 'reply')
    })
    LIVESDK.on('question:ask', (res) => {
        console.log('发起提问', res)
        _this.updateQuestionList(res)
    })
    LIVESDK.on('question:audit', (res) => {
        _this.updateQuestionList(res)
    })
    LIVESDK.on('question:delete', function (qid) {
        _this.updateQuestionList(qid, 'del')
    })
}

export default init
